import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import CorrespondentsTable from "../Common/CorrespondentsTable";

const Correspondents = () => {
  const [correspondents, setCorrespondents] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getCorrespondents().then((data) => setCorrespondents(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Correspondents")}
      <Divider align="center">
        <h1>Correspondents</h1>
      </Divider>
      <CorrespondentsTable
        data={correspondents}
        searchEnabled
        longDescription
      />
    </div>
  );
};

export default Correspondents;
